document.addEventListener('DOMContentLoaded', ()=>{


    const casesFilterWrapper = document.getElementById('casesFilterWrapper');

    if (!casesFilterWrapper){
        return
    }

    const casesFilterButton = casesFilterWrapper.querySelector('#casesFilterButton');
    const casesFilterList = casesFilterWrapper.querySelector('#casesFilterList');


    casesFilterButton.addEventListener('click', ()=>{
        casesFilterWrapper.classList.toggle('active');
    })


    document.addEventListener('click', function(e) {
        if (!e.target.closest('#casesFilterWrapper')) {
            // button.setAttribute('aria-expanded', 'false');
            casesFilterWrapper.classList.remove('active');
        }
    });
})